export const REQUEST_PHOTOS_UPLOAD = '[photos ui] Request Photos Upload';
export const UPDATE_LOADING_PHOTO = '[photos ui] Update Loading Photo';
export const DELETE_LOADING_PHOTO = '[photos ui] Delete Loading Photo';
export const PHOTO_UPLOAD = '[photos ui] Photo Upload';

export const REQUEST_PHOTO_DELETE = '[photos ui] Request Photo Delete';
export const PHOTO_DELETE = '[photos ui] Photo Delete';
export const PHOTO_DELETE_ERROR = '[photos ui] Photo Delete Error';

export const REQUEST_PHOTOS_REORDER = '[photos ui] Request Photos Reorder';
export const PHOTOS_REORDER = '[photos ui] Photos Reorder';
export const PHOTOS_REORDER_ERROR = '[photos ui] Photos Reorder Error';
